import React, { useEffect } from "react";
import useUserInformation from "../../../hooks/useUserInformation";
import Loading from "../../../modules/public/loading/loading";

export default function Logout(props) {
  const { deleteToken } = useUserInformation();

  useEffect(() => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    deleteToken();

    window.location.replace("/login");
  }, []);

  return <Loading />;
}
